module.exports = __webpack_public_path__ + "pic_bizny_web_01@2x.png?882dc0796f338beadd7fae60c6335620";